import { getNotificationSettings, saveNotificationSettings } from '@/api/gql'

/**
* Fetch user notifications behavior
*/
const fetchNotificationsSettings = async ({ commit }) => {
  return new Promise((resolve, reject) => {
    commit('FETCH_USER_NOTIFICATIONS_SUBMIT')
    getNotificationSettings()
      .then((response) => {
        if (response) {
          commit('FETCH_USER_NOTIFICATIONS_RESPONSE', response)
          resolve(response)
        } else {
          reject(Error('No response from server'))
        }
      })
      .catch((error) => {
        commit('FETCH_USER_NOTIFICATIONS_ERROR_RESPONSE', error)
        reject(error)
      })
      .finally(() => {
      })
  })
}

/**
* Set user notification behavior
*/
const setNotificationsSettings = async ({ commit }, notifications) => {
  return new Promise((resolve, reject) => {
    commit('SET_USER_NOTIFICATIONS_SUBMIT')

    saveNotificationSettings(notifications)
      .then((response) => {
        if (response) {
          commit('SET_USER_NOTIFICATIONS_SUCCESS')
          resolve(true)
        } else {
          reject(Error('No response from server'))
        }
      })
      .catch((error) => {
        commit('SET_USER_NOTIFICATIONS_ERROR_RESPONSE')
        reject(error)
      })
      .finally(() => {
      })
  })
}

export default {
  fetchNotificationsSettings,
  setNotificationsSettings
}



// WEBPACK FOOTER //
// ./src/store/modules/user/notifications/actions.js